import { Component, EventEmitter, Output, input } from '@angular/core';
import { AuthStoreSelector } from '@common/selectors/authentication.selector';
import { ContentBuilderFieldColors } from '@shared/interfaces/content-builder.interface';
import { FidelityType } from '../fidelity-type.enum';

@Component({
  selector: 'app-kiosk-account-not-found-step',
  template: `
    <div class="flex flex-col items-center justify-center gap-12">
      <h1
        class="w-full text-center text-4xl font-bold"
        [style.color]="accentColor()?.font | contentBuilderColor"
      >
        {{
          fidelityType() + '.create-or-link-account.kiosk-account-not-found-step.title'
            | translate: { phoneNumber: phone() }
        }}
      </h1>
      <div class="flex w-full flex-col gap-12">
        <app-button-atom
          size="L"
          [label]="
            fidelityType() +
              '.create-or-link-account.kiosk-account-not-found-step.update-phone-number' | translate
          "
          type="kiosk-primary"
          [overrideTextColor]="accentColor()?.font"
          [overrideBgColor]="accentColor()?.background"
          [disabled]="isRegistering()"
          (click)="onGoToPhoneStep()"
          [full]="true"
        ></app-button-atom>

        <app-button-atom
          size="L"
          [label]="
            fidelityType() + '.create-or-link-account.kiosk-account-not-found-step.register'
              | translate
          "
          type="kiosk-primary"
          [iconUrl]="isRegistering() ? 'assets/images/spinner.svg' : undefined"
          [disabled]="isRegistering()"
          [overrideTextColor]="accentColor()?.font"
          [overrideBgColor]="accentColor()?.background"
          (click)="onGoToRegisterStep()"
          [full]="true"
        ></app-button-atom>

        <app-button-atom
          size="L"
          [label]="
            fidelityType() +
              '.create-or-link-account.kiosk-account-not-found-step.order-without-account'
              | translate
          "
          (click)="completeStep()"
          [disabled]="isRegistering()"
          [overrideTextColor]="accentColor()?.font"
          [overrideBgColor]="accentColor()?.background"
          type="kiosk-light"
          [full]="true"
        ></app-button-atom>

        @if (errorMessage(); as message) {
          <p
            class="text-center font-base text-sm font-normal text-error-700"
            [translate]="message"
          ></p>
        }
      </div>
    </div>
  `,
  standalone: false,
})
export class KioskAccountNotFoundStep {
  @Output() onComplete = new EventEmitter<void>();
  @Output() goToPhoneStep = new EventEmitter<void>();
  @Output() goToRegisterStep = new EventEmitter<void>();

  readonly phone = input('');
  readonly accentColor = input<ContentBuilderFieldColors>();
  readonly fidelityType = input.required<FidelityType>();
  /** Blocks the CTAs while a register call started from this step is in flight. */
  readonly isRegistering = input(false);
  readonly errorMessage = input<string>();

  user$ = this.authSelector.selectUser$;

  constructor(private readonly authSelector: AuthStoreSelector) {}

  completeStep(): void {
    this.onComplete.next();
  }

  onGoToPhoneStep(): void {
    this.goToPhoneStep.next();
  }

  onGoToRegisterStep(): void {
    this.goToRegisterStep.next();
  }
}
